module.exports = __webpack_public_path__ + "img/banner-ship.b17dbc36.svg";